var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthors(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2450ff;}.b{fill:#6dcef8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-844 -1210)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,0H50a0,0,0,0,1,0,0V54a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(844 1210)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H4a6,6,0,0,1,6,6V20a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(894 1210)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 10,
    height: 2,
    rx: 1,
    transform: "translate(854 1223)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30,
    height: 2,
    rx: 1,
    transform: "translate(854 1235)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30,
    height: 2,
    rx: 1,
    transform: "translate(854 1245)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(854 1255)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthors);
export default __webpack_public_path__ + "static/media/authors.be3a7b9b676bc82b0abde506c76edf49.svg";
export { ForwardRef as ReactComponent };